// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderColumnGroup-module-root-1yv"};